import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export default function DeviceClass({ value, onChange, disabled = false }) {
  value = value !== null ? value : "";

  return (
    <FormControl fullWidth>
      <InputLabel>Device class</InputLabel>
      <Select value={value} label="Device class" disabled={disabled} onChange={(event) => onChange(event)}>
        <MenuItem value={"meter"}>Meter</MenuItem>
        <MenuItem value={"battery"}>Battery</MenuItem>
        <MenuItem value={"solar_inverter"}>Solar Inverter</MenuItem>
      </Select>
    </FormControl>
  );
}
